import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyPrefetchRoomsAvailabilityForRoomPanel } from 'owa-room-selection';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import type { OwaDate } from 'owa-datetime';

/**
 * this operation is somewhat expensive, so if a user is dragging an item through numerous different
 * start/end times, we want to wait until they've actually settled on one before calling this
 * in the background
 */

let timer;
const timerDelay = 500; //ms

export function prefetchRoomsAvailabilityForRoomPanel(
    eventStartDateTime: OwaDate,
    eventEndDateTime: OwaDate,
    isAllDayEvent: boolean,
    recurrence: RecurrenceType,
    requiredAttendees: AttendeeType[],
    optionalAttendees: AttendeeType[],
    originalEvent: CalendarEvent,
    formId: string
) {
    if (isFeatureEnabled('cal-advancedRoomBooking')) {
        // setTimeout so the action that called this doesn't need to wait for the whole load
        clearTimeout(timer);
        timer = setTimeout(() => {
            lazyPrefetchRoomsAvailabilityForRoomPanel.importAndExecute(
                eventStartDateTime,
                eventEndDateTime,
                isAllDayEvent,
                recurrence,
                requiredAttendees,
                optionalAttendees,
                originalEvent,
                formId
            );
        }, timerDelay);
    }
}
